module.exports = __webpack_public_path__ + "img/Slice6-min.4d62cabe.png";